import { render, staticRenderFns } from "./TechnologyPartner.info.vue?vue&type=template&id=388e9e29&scoped=true"
import script from "./TechnologyPartner.info.vue?vue&type=script&lang=js"
export * from "./TechnologyPartner.info.vue?vue&type=script&lang=js"
import style0 from "./TechnologyPartner.info.vue?vue&type=style&index=0&id=388e9e29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e9e29",
  null
  
)

export default component.exports